import React from "react";
const LeftArrow = props => (<svg width={props.width} height={props.height} viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 1L1 10.5L10 20" stroke="#f1f1f1" strokeOpacity="0.8" strokeLinecap="round" strokeLinejoin="round" /></svg>)
export default LeftArrow
